<template>
  <div>
    <v-card>
      <v-system-bar dark color="grey darken-1" height="50">
        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-arrow-left-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        {{ groupe.nom_groupe }} - {{ projet.ll_programme }}
        <v-spacer></v-spacer>

        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-system-bar>
      <v-card-text>
        <v-btn
          v-if="user.role != 'operateur'"
          @click="printPresence"
          block
          class="info rounded-pill my-4"
          ><v-icon class="mr-4">mdi-printer</v-icon> Imprimer fiche de
          distribution</v-btn
        >
        <dialogNewIntrant
          v-if="user.role != 'operateur'"
          :groupe="groupe"
          :projet="projet.ll_programme"
          :id="$route.params.id"
        />
        <template>
          <div class="text-center">
            <v-dialog v-model="dialogEditDotation" width="500">
              <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                  Edition de la dotation
                </v-card-title>

                <v-card-text>
                  <v-form>
                    <v-text-field
                      v-model="dotationSelected.ll_dotation"
                      label="Dotation"
                    ></v-text-field>

                    <!--   <v-autocomplete
                      dense
                      :items="activites"
                      label="Activités"
                      outlined
                      item-text="ll_parcours"
                      :value="dotationSelected.ll_parcours"
                      @change="selectActivite"
                      :rules="selectRules"
                      ref="activite_selected"
                      return-object
                    ></v-autocomplete> -->

                    <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="computedDateDotation"
                          label="Date de la dotation"
                          prepend-icon="mdi-calendar-cursor"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="fr"
                        v-model="dotationSelected.date_dotation"
                        no-title
                        @input="menu2 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-form>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-btn
                    rounded
                    color="warning"
                    @click="closeDialogEditDotation()"
                    >Annuler</v-btn
                  >
                  <v-btn rounded color="success" @click="doEditDotation()"
                    >Sauvegarder</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </template>
        <h2>
          Dotations du projet {{ projet.ll_programme }}
          <span
            v-if="
              user.role != 'regionalFull' || user.role === 'regionalReadOnly'
            "
          >
            <span v-if="user.role != 'operateur'"
              >(03 derniers mois)</span
            ></span
          >
        </h2>
        <v-list two-line subheader>
          <v-list-item
            v-for="(item, index) in DotsDeGroupe"
            :key="index"
            v-bind:class="item.dateFusion ? 'light-green-lighten-3' : ''"
          >
            <v-list-item-content style="padding: 20px;">
              <v-list-item-title v-html="item.ll_dotation"></v-list-item-title>
              <v-list-item-subtitle>
                {{ $moment(item.date_dotation).format("Do MMMM YYYY") }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ item.ll_programme }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ item.ll_parcours }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                Totaux intrants: {{ item.nombreTotal }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                Détails Tntrants: {{ item.nbDetail }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                Animateur : {{ item.nom_responsable }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="item.operateur">
                Vérifié par: {{ item.operateur }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="item.dateFusion">
                le: {{ $moment(item.dateFusion).format("Do MMMM YYYY") }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-list-item-action>
                <div class="row">
                  <div class="col mx-0 px-0 py-1">
                    <v-btn
                      @click="editDotation(item)"
                      class="mr-2"
                      fab
                      dark
                      x-small
                      color="warning"
                    >
                      <v-icon dark>
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </div>
                  <div
                    class="col mx-0 px-0 py-1"
                    v-if="
                      user.role === 'regionalFull' ||
                      user.role === 'regionalReadOnly'
                    "
                  >
                    <v-btn
                      @click="deleteDotationAndPresence(item)"
                      class="mr-2"
                      fab
                      dark
                      x-small
                      color="danger"
                    >
                      <v-icon dark>
                        mdi-trash-can
                      </v-icon>
                    </v-btn>
                  </div>
                  <div
                    class="col mx-0 px-0 py-1"
                    v-if="user.role != 'superviseur'"
                  >
                    <v-btn
                      class="mr-2"
                      fab
                      color="primary"
                      dark
                      x-small
                      @click="gotoPresenceDotationDeGroupe(item)"
                    >
                      <v-icon dark>mdi-chevron-right</v-icon>
                    </v-btn>
                  </div>
                  <!--        <div class="col mx-0 px-0 py-1"  v-if="user.role != 'superviseur'  || user.isPaysanRelais">
                    <v-btn
                      class="mr-2"
                      fab
                      color="primary"
                      dark
                      x-small
                      @click="gotoPresenceDotationDeGroupe(item)"
                    >
                      <v-icon dark>mdi-chevron-right</v-icon>
                    </v-btn>
                  </div> -->
                </div>
              </v-list-item-action>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      dialogEditDotation: false,
      dotationSelected: {
        ll_dotation: "",
        date_dotation: "",
      },
      selectedActivite: { ll_parcours: "", parcours_id_parcours: "" },
      menu2: false,
      selectRules: [(v) => !!v || "Veuillez sélectionner une valeur"],
      start: this.$moment(Date.now())
        .subtract(10, "years")
        .format("YYYY-MM-DD HH:mm:ss"),
      end: this.$moment(Date.now())
        .add(3, "days")
        .format("YYYY-MM-DD HH:mm:ss"),
    };
  },
  components: {
    etapesEffectives: require("@/components/groupes/etapesEffectives.vue")
      .default,
    vcol: require("@/components/groupes/col.vue").default,
    detailCampagne: require("@/components/groupes/detailCampagne.vue").default,
    dialogNewMembre: require("@/components/groupes/dialogNewMembre.vue")
      .default,
    dialogNewCampagne: require("@/components/groupes/dialogNewCampagne.vue")
      .default,
    dialogNewCycleGec: require("@/components/groupes/dialogNewCycleGec.vue")
      .default,
    dialogNewFormation: require("@/components/groupes/dialogNewFormation.vue")
      .default,
    dialogNewIntrant: require("@/components/groupes/dialogNewIntrant.vue")
      .default,
  },
  created() {
    if (
      this.user.role === "regionalFull" ||
      this.user.role === "regionalReadOnly" ||
      this.user.role === "operateur"
    ) {
      var objet = {
        userId: this.groupe.responsable,
        project: this.projet,
        start: this.start,
        end: this.end,
      };
      console.log(objet);
      this.GetDotationsDeGroupe(this.groupe.id);
      this.GetSuperviseurPresencesDotationsDeGroupe(objet);
    } else {
      console.log("Je suis un animateur");
    }
  },

  computed: {
    computedDateDotation() {
      return this.dotationSelected.date_dotation
        ? this.$moment(this.dotationSelected.date_dotation).format("DD-MM-YYYY")
        : "";
    },
    ...mapState({
      user: (state) => state.Auth.user,
      groupe: (state) => state.Groupes.itemById,
      MembresDugroupe: (state) => state.Membres.MembresDuGroupe,
      MembresDuGroupeActifs: (state) =>
        _.filter(state.Membres.MembresDuGroupe, { actif_dans_groupe: 1 }),
      ParcoursEffectif: (state) => state.ParcoursEffectif.ParcoursEffectif,
      FormationsDeGroupe: (state) =>
        state.FormationsDeGroupe.FormationsDeGroupe,
      DotationsDeGroupe: (state) => state.DotationsDeGroupe.DotationsDeGroupe,
      Campagnes: (state) => state.Campagnes.Campagnes,
      campagneActive: (state) => state.Campagnes.campagneActive,
      activites(state) {
        return _.filter(state.Activites.Activites, {
          programme_id_programme: this.projet.id,
        });
      },
      DotsDeGroupe(state) {
        return _.filter(state.DotationsDeGroupe.DotationsDeGroupe, {
          groupes_code_groupe: this.groupe.id,
        });
      },
      projet: function (state) {
        return _.filter(state.Projets.projets, {
          id: this.$route.query.idProjet,
        })[0];
      },
    }),
  },
  methods: {
    ...mapActions({
      GetDotationsDeGroupe: "DotationsDeGroupe/GetDotationsDeGroupe",
      GetMembresDuGroupe: "Membres/GetMembresDuGroupe",
      GetSuperviseurPresencesDotationsDeGroupe:
        "PresencesDotationsDeGroupe/GetSuperviseurPresencesDotationsDeGroupe",
    }),

    selectActivite(val) {
      //console.log("selectActivite", val.ll_parcours);
      //console.log("selectActivite", val.id);
      this.selectedActivite.ll_parcours = val.ll_parcours;
      this.selectedActivite.parcours_id_parcours = val.id;
    },
    editDotation(item) {
      this.dialogEditDotation = true;
      this.dotationSelected = item;
    },

    closeDialogEditDotation() {
      this.dotationSelected = {
        ll_dotation: "",
        date_dotation: "",
      };
      this.dialogEditDotation = false;
    },

    doEditDotation() {
      var self = this;
      var id = this.dotationSelected.id;
      var lobjet = {
        ll_dotation: self.dotationSelected.ll_dotation,
        date_dotation: self.dotationSelected.date_dotation,
      };

      if (self.selectedActivite.parcours_id_parcours != "") {
        lobjet.ll_parcours = self.selectedActivite.ll_parcours;
        lobjet.parcours_id_parcours =
          self.selectedActivite.parcours_id_parcours;
      }

      //Modifier Dotation:
      var ref = this.$firebase
        .firestore()
        .collection("dotationsDeGroupe")
        .doc(this.dotationSelected.id);

      ref
        .set(lobjet, { merge: true })
        .then(() => {
          console.log("Dotation modified ID: ", id);
          // Modifier Présences de la Dotation

          const PresencesDotations = self.$firebase
            .firestore()
            .collection("presencesDotationsGroupes");
          var lobjet2 = {
            ll_dotation_groupe: self.dotationSelected.ll_dotation,
            date_dotation_groupe: self.dotationSelected.date_dotation,
          };

          if (self.selectedActivite.parcours_id_parcours != "") {
            lobjet2.ll_parcours = self.selectedActivite.ll_parcours;
            lobjet2.parcours_id_parcours =
              self.selectedActivite.parcours_id_parcours;
          }
          var i = 1;
          PresencesDotations.where(
            "dotations_groupes_id_dotation_groupe",
            "==",
            id
          )
            .get()
            .then((snapshots) => {
              console.log("PresencesDotations successfully updated!");
              if (snapshots.size > 0) {
                snapshots.forEach((snap) => {
                  PresencesDotations.doc(snap.id).set(lobjet2, { merge: true });
                  console.log(
                    "PresencesDotations successfully updated! for : " +
                      i++ +
                      " members"
                  );
                });
              } else {
                console.log("no snap PresencesDotations");
              }
            });
        })
        .catch((error) => {
          console.error("Error Editing document: ", error);
        });
      this.GetDotationsDeGroupe(this.groupe.id);
      this.closeDialogEditDotation();
    },

    deleteDotationAndPresence(item) {
      let self = this;
      var id = item.id;
      var idGroupe = item.groupes_code_groupe;
      const PresencesDotations = self.$firebase
        .firestore()
        .collection("PresencesDotationsGroupes");
      this.$confirm(
        "Voulez vous vraiment supprimer la séance de dotation : <strong>" +
          item.ll_dotation +
          "</strong> ?, et sa fiche de distribution ?"
      ).then((res) => {
        if (res) {
          console.log("deleteDotationAndPresence", item);
          var ref = this.$firebase
            .firestore()
            .collection("dotationsDeGroupe")
            .doc(item.id);

          ref
            .delete()
            .then(() => {
              PresencesDotations.where(
                "dotations_groupes_id_dotation_groupe",
                "==",
                id
              )
                .get()
                .then((snapshots) => {
                  console.log("PresencesDotations successfully deleted!");
                  if (snapshots.size > 0) {
                    snapshots.forEach((snap) => {
                      PresencesDotations.doc(snap.id).delete();
                    });
                  } else {
                    console.log("no snap PresencesDotationsGroupes");
                  }
                });
              self.GetDotationsDeGroupe(idGroupe);
            })
            .catch((error) => {
              console.error("Error removing document: ", error);
            });
        }
      });
    },

    printPresence() {
      console.log("printPresence");
      var objectToSend = {
        membres: this.MembresDuGroupeActifs,
      };

      this.$router.push({
        name: "detailsGroupe-listeDotationsDeGroupe-print",
        params: objectToSend,
      });
    },

    gotoPresenceDotationDeGroupe(item) {
      this.$router.push({
        path: `/groupes/presenceDotationGroupe/${item.id}`,
        query: {
          projet: this.$route.params.id,
          ll_dotation: item.ll_dotation,
          idAnimateur: item.responsable,
          idGroupe: item.groupes_code_groupe,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
